import { legacy_createStore as createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from '../reducers/authReducer';
import drawerReducer from '../reducers/drawerReducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import ordersReducer from '../reducers/ordersReducer';
import InvoicesReducer from '../reducers/InvoicesReducer';
import InvoicesCustomerReducer from '../reducers/InvoicesCustomerReducer';
import categorysReducer from '../reducers/categorysReducer';
import productsReducer from '../reducers/productsReducer';
import brandReducer from '../reducers/brandReducer';
import xmlReducer from '../reducers/xmlReducer';
import provider from '../reducers/provider';
import categoryVariantReducer from '../reducers/categoryVariantReducer';
import attributeReducer from '../reducers/attributeReducer';
import ourWardCategoryReducer from '../reducers/OurWardCategoryReducer';
import ourWardCategoryAttributeReducer from '../reducers/OurWardCategoryAttributeReducer';
import outWardBrandReducer from '../reducers/OutWardBrandReducer';
import BulkPriceTransactionReducer from '../reducers/BulkPriceTransactionReducer';
import BulkTextTransactionReducer from '../reducers/BulkTextTransactionReducer';
import storeReducer from '../reducers/storeReducer';
import priceRuleReducer from '../reducers/priceRuleReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  drawer: drawerReducer,
  orders: ordersReducer,
  invoices: InvoicesReducer,
  invoicesCustomer: InvoicesCustomerReducer,
  categorys: categorysReducer,
  brands: brandReducer,
  products: productsReducer,
  xml: xmlReducer,
  providers: provider,
  categoryVariant: categoryVariantReducer,
  attributes: attributeReducer,
  outWardCategory: ourWardCategoryReducer,
  outWardCategoryAttribute: ourWardCategoryAttributeReducer,
  outWardBrand: outWardBrandReducer,
  bulkPriceTransaction: BulkPriceTransactionReducer,
  bulkTextTransaction: BulkTextTransactionReducer,
  store: storeReducer,
  priceRule: priceRuleReducer
});
const store = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

export default store;
